import { lazy } from "react";

// project-imports
import Loadable from "components/Loadable";

/**
 * Lazy-loaded component for rendering the list of Users.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ListUserPage - Lazy-loaded ListUserPage component.
 */
const ListUserPage = Loadable(lazy(() => import("./ListUserPage")));

/**
 * Lazy-loaded component for rendering the add User page.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} AddUserPage - Lazy-loaded AddUserPage component.
 */
const AddUserPage = Loadable(lazy(() => import("./AddUserPage")));

/**
 * Lazy-loaded component for rendering the View User page.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ViewUserPage - Lazy-loaded ViewUserPage component.
 */
const ViewUserPage = Loadable(lazy(() => import("./ViewUserPage")));

/**
 * Lazy-loaded component for rendering the View User page.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ViewUserPage - Lazy-loaded ViewUserPage component.
 */
const EditUserPage = Loadable(lazy(() => import("./EditUserPage")));

/**
 * Array containing route definitions for the User-related pages.
 * @constant {Object[]} UserRoutes - Array of User route objects.
 * @property {string} UserRoutes[].path - The path of the User route.
 * @property {React.ReactElement} UserRoutes[].element - The React element to be rendered for the User route.
 */
const UserRoutes = [
  {
    path: "list",
    element: <ListUserPage />,
  },
  {
    path: "add",
    element: <AddUserPage />,
  },
  {
    path: "view/:user_id",
    element: <ViewUserPage />,
  },
  {
    path: "edit/:user_id",
    element: <EditUserPage />,
  },
];

export default UserRoutes;
